import { ChevronsLeft, ChevronsRight } from "lucide-react";
// Décommenter l'import du SVG
import { ReactComponent as Logo } from "../../../assets/titreLigneB.svg";

const MenuToggleButton = ({ isOpen, onToggle }) => (
    <div style={{ 
      display: 'flex', 
      width: '100%',
      alignItems: 'center',
      borderTop: '4px solid var(--colorFront)',
      borderBottom: '2px solid var(--colorFront)'
    }}>
      {/* Logo à gauche - visible seulement quand le menu est ouvert */}
      {isOpen && (
        <div style={{ 
          flex: 1, 
          display: 'flex', 
          alignItems: 'center',
          paddingLeft: '4px',
          height: '40px',
          overflow: 'hidden'
        }}>
          <Logo 
            style={{ 
              width: '100%', 
              height: 'auto',
              maxHeight: '32px',
              objectFit: 'contain'
            }}
            alt="Titre"
          />
        </div>
      )}
      
      {/* Bouton toggle - reste à droite */}
      <button
          className={`menu-toggle-btn ${isOpen ? "open" : "closed"}`}
          onClick={onToggle}
          style={{
            width: isOpen ? '40px' : '100%', // Largeur réduite quand le menu est ouvert
            flexShrink: 0
          }}
      >
          {isOpen ? <ChevronsLeft size={24} /> : <ChevronsRight size={24} />}
      </button>
    </div>
);

export default MenuToggleButton;